module.exports = __webpack_public_path__ + "static/media/List.361d5414.svg";